/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {MediaBlock} from './MediaBlock'
import {type MediaBlockProps} from './types'

const MediaBlockIcon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 16.8824H18V1H0V16.8824ZM1.05882 15.8246H16.9412V2.05882H1.05882V15.8246ZM3.3533 12.6471C4.13577 10.1059 4.77212 9.55318 5.09506 9.45788C5.48259 9.34882 6.012 9.8073 6.52024 10.2584C7.12377 10.7909 7.73259 11.3468 8.49283 11.2568C8.92377 11.2071 9.30918 10.9445 9.63953 10.4775C10.6973 8.98459 11.7572 8.23388 12.5354 8.41494C13.4629 8.63094 14.2497 10.1609 14.7229 12.6471H3.3533ZM15.876 13.0928C15.3254 9.65482 14.2814 7.73411 12.7747 7.38364C11.8916 7.17717 10.4887 7.44399 8.77447 9.86658C8.67177 10.0116 8.5193 10.1874 8.37 10.2043C8.07247 10.2255 7.62988 9.82635 7.22118 9.46529C6.53188 8.85329 5.75577 8.15976 4.79436 8.44247C3.75883 8.74847 2.93824 10.1641 2.13777 13.0335L1.9493 13.7059H15.9745L15.876 13.0928ZM6.35295 4.17647C6.93742 4.17647 7.41178 4.65189 7.41178 5.2353C7.41178 5.81871 6.93742 6.29412 6.35295 6.29412C5.76848 6.29412 5.29413 5.81871 5.29413 5.2353C5.29413 4.65189 5.76848 4.17647 6.35295 4.17647ZM6.35296 7.35295C7.52084 7.35295 8.4706 6.40318 8.4706 5.2353C8.4706 4.06742 7.52084 3.11765 6.35296 3.11765C5.18507 3.11765 4.23531 4.06742 4.23531 5.2353C4.23531 6.40318 5.18507 7.35295 6.35296 7.35295Z" fill="currentColor"/>
</svg>`

export {MediaBlock, MediaBlockIcon, type MediaBlockProps}
